angular.module('ngApp')
.controller('badgeController', ['Modal', function (Modal) {
  Modal.open({ templateUrl: 'modalBadge.html' })
}]);
